import { AppState } from "@Safemate/Store/types";
import { RootState } from "./types";

export const getCustomers = ({  partnerDashboard: {customer: {customers}}}: AppState) => customers;

export const getFilters = ({ partnerDashboard: {filter}}: AppState) => filter;